module.exports = __webpack_public_path__ + "static/media/logo-right.7c27ea25.png";